import React from "react";
import { backendUrl } from "../../api/constants";

const Icon = ({ src, style, className, imgClassName }) => {
  // If src starts with 'images/services', it's a backend-served icon
  const iconSrc = src?.startsWith('images/services') ? `${backendUrl}/${src}` : src;

  return (
    <div className={className} style={{ ...styles.default, ...(style || {}) }}>
      <img 
        className={imgClassName}
        src={iconSrc} 
        style={styles.imageStyle} 
      />
    </div>
  );
};

const styles = {
  default: {
    width: "100%",
    height: "100%",
    display: "flex",
    // backgroundColor: "red",
  },
  imageStyle: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
  },
};

export default Icon;
